<div class="card">
  <div class="card-header border-bottom border-secondary pb-4">
    <h5 class="mb-0">Assigned products</h5>
  </div>
  <div class="card-body">
    <app-account-products productList="student"  [schoolId]="schoolId" [productsAdapter]="adapter"></app-account-products>
  </div>
</div>
